
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { fromDTO } from './mappers/userFlow';
import { publishAndAwait } from '../../../app/coreSlice';

const listCustomers = async ({
	string: filter,
	page,
}) => {

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'CUSTOMER',
			subType: 'OPERATORS_LIST',
			message: {
				filter,
				page,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	}

	const { customers, lastPage } = processMessage;

	const users = customers
		.reduce((acc, user) => ({...acc, [user.customerCode]: fromDTO(user)}), {});
		
	return {
		users,
		lastPage,
	};
};

export default listCustomers;
